export default __webpack_public_path__ + "static/media/faq_flower_2.f0e7c204.png";